
import { useState, useEffect, React } from "react";
import * as FaIcons from "react-icons/fa";
import { Button, Modal, Container, Row, Col, FormControl, FormLabel } from 'react-bootstrap';
import UsersList from './UsersList';
import UserService from './services/user.serviceaux';
import OrganigramaAreaDataService from './services/organigramaarea.service';
import Table from 'react-bootstrap/Table';
import Tooltip from 'react-bootstrap/Tooltip';
import { dtFormatter } from "./AuxiliaryFunctions";
import { useDispatch } from 'react-redux';
import { logout } from "./actions/auth.js";

function CompetenciasAreasJuez(props) { 
  const [lgShow, setLgShow] = useState(false);
  const [username,setUsername] = useState('');
  const [sorttype, setSorttype] = useState('ASC');
  const [sortfield, setSortfield] = useState('id');
  const [listOfAreas, setlistOfAreas] = useState([]);

  const organigramaid = props.organigramaid;
  const competenciaid = props.competenciaid;
  const userid = props.userid;  
  const showPlain = props.showPlain;

  const dispatch = useDispatch();

  const handleClose = () => setLgShow(false);

  const handleShow = () => {
    setLgShow(true);      
    console.log(listOfAreas);      
  }

  const onChangeFilterByDescr = (e) => {
    setUsername(e.target.value)
    performSearch(e.target.value,sortfield,sorttype);
  }  

  const performSearch = (organigramaid,competenciaid,userid) => {
    if (props.showPlain === 1) {
      OrganigramaAreaDataService.getCompetenciasAreasUsuarios(userid)
        .then(resp => {
          console.log(resp.data);
          setlistOfAreas(resp.data);
        })
        .catch((e) => {
          console.log(e);
          if (e.response.status == 401) {
            dispatch(logout())
            .then(() => {
              window.location.reload();
            });
          }
          else {
            console.log(e.response.data);
            /*
            setSuccmessage("");
            setShowsuccess(false);
            setErrmessage(e);
            setShowerror(true);
            */
          }
        });     
    }
    else {
      OrganigramaAreaDataService.getList(organigramaid, competenciaid, userid)
        .then(resp => {
          console.log(resp.data);
          setlistOfAreas(resp.data);
        })
        .catch((e) => {
          if (e.response.status == 401) {
            dispatch(logout())
            .then(() => {
              window.location.reload();
            });
          }
          else {
            console.log(e.response.data);
            setSuccmessage("");
            setShowsuccess(false);
            setErrmessage(e);
            setShowerror(true);
          }
        });     
    }
  };

  useEffect(() => {performSearch(organigramaid,competenciaid,userid)},[]);

    return (
      <>
        {(props.showPlain === 1) &&
        <CompetenciasAreasJuezList handleClose={handleClose} onSelected={props.onSelected} listOfAreas = {listOfAreas} mode = {1}/>      
        }
        {(props.showPlain === 0) &&
        <>
        <Button className='ms-2 btn-secondary' lg={8} style={{maxWidth:"50px",maxHeight:'38px'}} variant="primary" onClick={handleShow}><FaIcons.FaSearch /></Button>      
        <Modal
          size="lg"
          show={lgShow}
          onHide={() => setLgShow(false)}
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              {'Lista de áreas a las que fuiste asignado'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <Row>
                <CompetenciasAreasJuezList handleClose={handleClose} onSelected={props.onSelected} listOfAreas = {listOfAreas} mode = {1}/>      
              </Row>
            </Container>

          </Modal.Body>
        </Modal>
        </>
        }

      </>
    );
  }

  const TableHeader = (props) => {
  return (

    <thead>
      <tr>
        <th style={{width:'8%'}}>Competencia</th>
        <th style={{width:'15%'}}>Fecha</th>
        <th style={{width:'15%'}}>Area N1</th>
        <th style={{width:'40%'}}>Descripción posición</th>
        <th style={{width:'10%'}}>Salario</th>
        <th style={{width:'20%'}}>Evaluación</th>
        {/*<th className='d-none d-sm-table-cell' style={{width:'30%'}}>Descripción</th>*/}
      </tr>
    </thead>
  )
}

const TableBody = (props) => {
  if (props.listOf) {
    const rows = props.listOf.map((row, index) => { 
      return (      
        <tr key={index}>        
          <td>
            {row.nombrecompetencia}
          </td>        
          <td>
            {dtFormatter(new Date(row.fechainicio),1)}
          </td>
          <td>
            {row.parentarean1}
            {/*{row.childcategory}*/}
          </td>
          <td>          
            {row.nombreareaorposicion}
          </td>
          <td style={{textAlign:"right"}}>
            {row.salario?"$" + row.salario.toFixed(2):""}
          </td>
          <td>
            {row.evaluacion}
          </td>
          {/** 
          <td>  
            {row.descripcionareaoposicion}
          </td>
          */}
        </tr>
      )
    })
    return (
      <tbody>
        {rows}
      </tbody>
    )  
  }
  else {
    return null;
  }
}

const renderEditTooltip = (props) => (
  <Tooltip id="button-tooltip" {...props}>
    Click to edit the user.
  </Tooltip>
);



const CompetenciasAreasJuezList = (props) => {        
  
  return (
      <>
      <Container>
        <Row>
          <Table style={{verticalAlign:"baseline"}} striped bordered hover size="sm">
            <TableHeader mode={props.mode} />
            <TableBody handleClose={props.handleClose} onSelected={props.onSelected} mode={props.mode} listOf={props.listOfAreas} />
          </Table>
        </Row>
        <hr/>
      </Container>
      </>
    );
}

  
  export default CompetenciasAreasJuez;